// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"be0c1633","703":"27f873a3"}[chunkId] + ".chunk.js";
};